module.exports = __webpack_public_path__ + "img/al.01225be.svg";